import React from 'react';

import NodeGraph from './NodeGraph';

function CounterNodeGraph() {
  return (
    <NodeGraph
      initialState={{
        count: 0,
      }}
      rows={[
        [
          {
            label: 'App',
          },
        ],
        [
          {
            label: 'Counter',
            parentId: 'app',
            ownsState: 'count',
          },
        ],
        [
          {
            label: 'BigCountNumber',
            parentId: 'counter',
            props: ['count'],
            dependsOnState: ['count'],
          },
        ],
      ]}
    />
  );
}

export default CounterNodeGraph;
